import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/LogoW.webp';

export default function SignupPage() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState(() => {
    let name = '';
    let email = '';
    try {
      const pending = localStorage.getItem('pixly_pending_booking');
      if (pending) {
        const parsed = JSON.parse(pending);
        if (parsed.full_name) name = parsed.full_name;
        if (parsed.email) email = parsed.email;
      }
    } catch (_) {}
    return { name, email, password: '', confirm: '' };
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Full name is required';
    if (!form.email.trim()) e.email = 'Email is required';
    if (form.password.length < 8) e.password = 'Password must be at least 8 characters';
    if (form.password !== form.confirm) e.confirm = 'Passwords do not match';
    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setErrors({});
    setLoading(true);
    try {
      await signup(form.name, form.email, form.password);
      // Pass email to verify page
      sessionStorage.setItem('pixly_otp_email', form.email);
      navigate('/verify');
    } catch (err) {
      setErrors({ api: err.response?.data?.error || 'Signup failed. Try again.' });
    } finally {
      setLoading(false);
    }
  };

  const field = (key, label, type = 'text', placeholder = '') => (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display: 'block', fontSize: 12, color: '#a0a0b8', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{label}</label>
      <input
        type={type} value={form[key]}
        onChange={e => setForm({ ...form, [key]: e.target.value })}
        placeholder={placeholder}
        style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: `1px solid ${errors[key] ? '#E34364' : 'rgba(255,255,255,0.1)'}`, borderRadius: 10, padding: '12px 14px', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
      />
      {errors[key] && <p style={{ margin: '4px 0 0', fontSize: 12, color: '#E34364' }}>{errors[key]}</p>}
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#0B0F1F', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px 16px', fontFamily: 'Arial, Helvetica, sans-serif' }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Link to="/"><img src={logo} alt="PixlyBooth" style={{ maxWidth: 160 }} /></Link>
        </div>

        <div style={{ background: 'linear-gradient(135deg, #101428 0%, #0D0F20 100%)', borderRadius: 18, padding: 32, border: '1px solid rgba(227,67,100,0.3)', boxShadow: '0 20px 60px rgba(0,0,0,0.5)' }}>
          <h1 style={{ margin: '0 0 4px', fontSize: 22, color: '#E34364', fontWeight: 700 }}>Create your account</h1>
          <p style={{ margin: '0 0 28px', fontSize: 13, color: '#a0a0b8' }}>Start booking your Pixly Booth experience</p>

          {errors.api && (
            <div style={{ background: 'rgba(227,67,100,0.1)', border: '1px solid rgba(227,67,100,0.3)', borderRadius: 10, padding: '12px 16px', marginBottom: 20, color: '#E34364', fontSize: 13 }}>
              {errors.api}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {field('name', 'Full Name', 'text', 'Jane Smith')}
            {field('email', 'Email Address', 'email', 'you@example.com')}
            {field('password', 'Password', 'password', '8+ characters')}
            {field('confirm', 'Confirm Password', 'password', 'Repeat password')}

            <button
              type="submit" disabled={loading}
              style={{ width: '100%', background: loading ? '#555' : '#E34364', color: '#fff', border: 'none', borderRadius: 50, padding: '14px 0', fontSize: 14, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', marginTop: 8 }}
            >
              {loading ? 'Creating account…' : 'Create Account →'}
            </button>
          </form>

          <p style={{ textAlign: 'center', marginTop: 24, fontSize: 13, color: '#a0a0b8' }}>
            Already have an account?{' '}
            <Link to="/login" style={{ color: '#E34364', textDecoration: 'none', fontWeight: 600 }}>Sign in</Link>
          </p>
        </div>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: '#555' }}>
          <Link to="/" style={{ color: '#555', textDecoration: 'none' }}>← Back to homepage</Link>
        </p>
      </div>
    </div>
  );
}
